<script>
import PopperWrapper from './PopperWrapper.vue'

export default {
  ...PopperWrapper,
  name: 'VMenu',
  vPopperTheme: 'menu',
}
</script>
